import { useDispatch, useSelector } from "react-redux";
import {Switch, Typography} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import FiltersSection from "../../Filters/FiltersSection";
import {makeStyles} from "@material-ui/core/styles";
import {getOSMovimentadasDetalhado, getTempoEtapas} from "../../../actions/orderActions"
import {getEtapas} from "../../../actions/stationActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import {getThotI4Monitor} from "../../../actions/thotActions";
import I4PlantGrid from "./I4PlantGrid";
import {getConcluidosPorData, getMetasPeriodo} from "../../../actions/i4Actions";


const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    listaOS: {
      display: 'flex',
      flexDirection: "row",
      flexWrap: "wrap"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

const ThotI4Monitor = ({

                    }) => {
    const classes = useStyles();

    const [show, setShow] = useState(false);
    const [bMostrarEtapas, setbMostrarEtapas] = useState(false)
    const [bMostrarKpis, setbMostrarKpis] = useState(false)
    const st = useSelector(state => state);
    const i4Monitor = useSelector(state => state.thot.i4Monitor);
    const isFetchingi4Monitor = useSelector(state => state.thot.isFetchingi4Monitor);


    const dispatch = useDispatch();



    useEffect( () => {
        dispatch(getThotI4Monitor());
    }, []);



    const onFilterClick = () => {
        dispatch(getThotI4Monitor());
    }

      const handleChange = () => {
            setbMostrarEtapas(!bMostrarEtapas);
      }

    const handleChangeKpis = () => {
        setbMostrarKpis(!bMostrarKpis);
    }




    return (
        <React.Fragment>
            <Grid container direction="column" className={classes.dashboardSection}>
                <Grid item xs={12}>
                    <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false}  onFilterClick={onFilterClick} loading={isFetchingi4Monitor} />
                </Grid>
                <Grid item xs={12}>
                    <Switch checked={bMostrarKpis} onChange={handleChangeKpis} name="filtroTodosKpis"  />
                    <Switch checked={bMostrarEtapas} onChange={handleChange} name="filtroEtapas" />
                </Grid>
            </Grid>


                <Grid container item className={classes.listaOS} xs={12} sm={12} lg={12} xl={12}>

                    { !isFetchingi4Monitor  && i4Monitor.length > 0 &&
                        <React.Fragment>

                            { i4Monitor
                                .map( (e, ix) => {

                                     return (<I4PlantGrid key={ix} planta={e} index={ix} mostrarEtapas={bMostrarEtapas} mostrarTodosKPIs={bMostrarKpis}/> );
                                    //return(<React.Fragment key={ix}/>)
                                }) }
                        </React.Fragment>

                    }
                    { isFetchingi4Monitor &&
                        <React.Fragment>
                            <CircularProgress color="primary" />
                        </React.Fragment>
                    }
                </Grid>


        </React.Fragment>
    )

}

export default ThotI4Monitor;
